/* eslint-disable import/extensions */

import Moment from 'moment-timezone';
import 'moment/locale/ca';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/fr-ca';
import 'moment/locale/nl';
import 'moment/locale/pt';
import 'moment/locale/pt-br';

window.moment = Moment;
